// extracted by mini-css-extract-plugin
module.exports = {"confirmation":"Styles_confirmation__c1KOG","h2":"Styles_h2__q6AE_","h3":"Styles_h3__eomxE","h4":"Styles_h4__4xQLR","text":"Styles_text__1RG9h"};